// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".select-ppt__item[data-v-2c6e5b14] {\n  height: 32px;\n  line-height: 32px;\n  padding: 0 12px;\n}\n.select-ppt__item[data-v-2c6e5b14]:hover {\n  background: #e6f7ff;\n  cursor: pointer;\n}\n.select-ppt__item.selected[data-v-2c6e5b14] {\n  color: rgba(0, 0, 0, 0.65);\n  font-weight: 600;\n  background-color: #fafafa;\n}\n", ""]);
// Exports
module.exports = exports;
